import { COMMERCIAL_ENDPOINTS } from '../../../utils/api/endpoints/commercialEndpoints';
import { AllCommercialRequestParams, UseCommerciauxResponse } from './useCommerciaux.types';

const PREFIX = '[commerciauxQuery]';

export const queryAllCommerciaux = async (params: AllCommercialRequestParams) => {
  console.log(PREFIX, `Fetching commerciaux...`);
  const response = await COMMERCIAL_ENDPOINTS.getAll(params);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received commerciaux.`);
  return json as UseCommerciauxResponse;
};
